import { httpInterceptor } from '../http-interceptor';

export class CustomerService {
  static ENDPOINTS = {
    GET_ALL: 'customer/getall',
    GET_ALL_CUSTOMERS: 'Customer/getall',
    UPLOAD_DOCUMENT: 'customer/upload',
    ADD_CUSTOMER: 'Customer/savecustomer',
    GET_LABELS: 'Customer/getalllabels',
    GET_BY_ID: 'customer/getbyid'
  };

  static async getLabels() {
    return httpInterceptor.get(this.ENDPOINTS.GET_LABELS);
  }

  static async getAllCustomers() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL);
  }

  static async createCustomer(data) {
    return httpInterceptor.post(this.ENDPOINTS.ADD_CUSTOMER, data);
  }

  static async getAllCustomersList() {
    return httpInterceptor.get(this.ENDPOINTS.GET_ALL_CUSTOMERS);
  }

  static async uploadDocument(documentData) {
    return httpInterceptor.postfile(this.ENDPOINTS.UPLOAD_DOCUMENT, documentData);
  }

  static async getCustomerById(customerId) {
    return httpInterceptor.get(`${this.ENDPOINTS.GET_BY_ID}/${customerId}`);
  }
}
